import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey: 'sk-svcacct-sZI1c34j6gbDN-rrMy_064Nnr1oSWVA-YyhNHjH3elsSFyubVmuZIMX6DVr-HprT3BlbkFJn6YMBce-hmlSziFomymMYNS_2xRQ1oXqG4c_fI_ZBGFAtCQ29eVQC32_kkx2OAA',
  dangerouslyAllowBrowser: true
});

export const generateImageDescription = async (imageUrl: string, prompt: string): Promise<string | null> => {
  try {
    if (!imageUrl || !prompt) {
      throw new Error('URL de imagen o prompt no válidos');
    }

    const completion = await openai.chat.completions.create({
      model: "gpt-4o-mini",
      messages: [
        {
          role: "system",
          content: "Eres un experto en decoración navideña que analiza árboles de Navidad."
        },
        {
          role: "user",
          content: [
            {
              type: "text",
              text: prompt
            },
            {
              type: "image_url",
              image_url: {
                url: imageUrl
              }
            }
          ]
        }
      ],
      max_tokens: 500,
      temperature: 0.7
    });

    const description = completion.choices[0]?.message?.content;
    if (!description) {
      throw new Error('No se pudo generar una descripción');
    }

    return description;
  } catch (error: any) {
    console.error('Error generando descripción:', error);
    
    if (error.error?.message) {
      throw new Error(error.error.message);
    } else if (error.message) {
      throw new Error(error.message);
    } else {
      throw new Error('Error al generar la descripción');
    }
  }
};